import { httpClient } from '../http/httpClient.js';
import { planService } from '../plans/planService.js';

const COMPANY_API_URL = '/api/company';

const buildCompanyUrl = (params = {}) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `${COMPANY_API_URL}?${qs}` : COMPANY_API_URL;
};

const getCompaniesCollection = (payload) => {
  if (Array.isArray(payload?.companies))
    return payload.companies;
  return [];
};

export const normalizeCompany = (c) => ({
  ...c,
  id:               c.id,
  name:             c.name,
  hasGeoApi:        c.hasGeoApi,
  notificationData: c.notificationData,
  planId:           c.planId,
});

export const companyService = {
  getCompanies: async (params = {}) => {
    const payload = await httpClient.get(buildCompanyUrl(params));
    const list = getCompaniesCollection(payload);
    return {
      companies:  list.map(normalizeCompany),
      pagination: payload?.pagination ?? null,
    };
  },

  createCompany: async (data) =>
    httpClient.post(COMPANY_API_URL, { data }),

  updateCompany: async (id, data) =>
    httpClient.put(`${COMPANY_API_URL}/${encodeURIComponent(id)}`, { data }),

  deleteCompany: async (id) =>
    httpClient.delete(`${COMPANY_API_URL}/${encodeURIComponent(id)}`),

  getPlans: async (params = {}) => planService.getPlans(params),
};
